export interface City {
    id: number;
    name: string;
    zip: string;
}

export interface CityDto {
    City: string;
    Id: number;
    Zip: string;
}

export function cityFromDto(dto: CityDto): City {
    return {
        id: dto.Id,
        name: dto.City,
        zip: dto.Zip,
    };
}
